
const DAY = 24 * 60;

export function maskTime(input: string): string {
  const digits = input.replace(/\D/g, '').slice(0, 4);
  if (digits.length === 0) return '';
  if (digits.length === 1) return Number(digits) > 2 ? `0${digits}:` : digits;

  let hh = digits.slice(0, 2);
  if (Number(hh) > 23) hh = '23';
  const rest = digits.slice(2);
  if (rest.length === 0) return `${hh}:`;
  if (rest.length === 1) return Number(rest) > 5 ? `${hh}:0${rest}` : `${hh}:${rest}`;
  return `${hh}:${Number(rest) > 59 ? '59' : rest}`;
}

export function maskTimeEdit(next: string, previous: string): string {
  const deleting = next.length < previous.length;
  const digits = next.replace(/\D/g, '');
  const masked = maskTime(digits);
  if (deleting && masked === previous) return maskTime(digits.slice(0, -1));
  return masked;
}

export function completeTime(value: string): string {
  const digits = value.replace(/\D/g, '');
  if (digits.length === 0) return '';
  const hh = digits.slice(0, 2).padStart(2, '0');
  const mm = digits.slice(2).padEnd(2, '0');
  const hours = Math.min(Number(hh), 23);
  const minutes = Math.min(Number(mm), 59);
  return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
}

export function stepTime(value: string, deltaMinutes: number, base = '09:00'): string {
  const from = completeTime(value) || base;
  const [h, m] = from.split(':').map(Number);
  const total = (((h * 60 + m + deltaMinutes) % DAY) + DAY) % DAY;
  return `${String(Math.floor(total / 60)).padStart(2, '0')}:${String(total % 60).padStart(2, '0')}`;
}
